import { IRegisterUser } from './auth';

export interface ISelect {
    id: string | number;
    code?: string;
    name: string;
    surname?: string;
    parent?: ISelect;
    valueSmart?: string;
    username?: string;
    project?: ISelect;
}

export interface Attachment {
    id?: string;
    name: string;
    extension?: string;
    base64?: string;
    url?: string;
    createdBy?: IRegisterUser;
    created_at?: Date;
}

export interface ResponseData {
    deliveryId?: string;
    message?: string;
    statusCode?: number | string;
    status?: number | string;
}

export enum UserTypeEnum {
    SuperAdmin = 'super admin',
    Admin = 'admin',
    TenderManager = 'manager',
}

export enum ParamEnum {
    COMMERCIAL_MANAGER = 'COMMERCIAL_MANAGER',
    PROCESS_TYPE = 'PROCESS_TYPE',
    DELIVERY_METHOD = 'DELIVERY_METHOD',
    ARCHITECTURE_MANAGER = 'ARCHITECTURE_MANAGER',
    STATUS_PROCESS = 'STATUS_PROCESS',
}
